import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

const _log:boolean = false;

@Injectable({
	providedIn: 'root'
})
export class GlobalWatchService {

	private _hasCookie: boolean;
	private _hasCookie_Source = new Subject<boolean>();
	public hasCookie$ = this._hasCookie_Source.asObservable();

	constructor() {
		if (_log) console.log('GlobalWatchService.constructor');
	}

	public setHasCookie(bool: boolean) {
		if (_log) console.log("GlobalWatchService.setHasCookie()", bool);
		this._hasCookie = bool;
		this._hasCookie_Source.next(this._hasCookie);
	}
	public getHasCookie(){
		if (_log) console.log("GlobalWatchService.getHasCookie()");
		return this._hasCookie;
	}
}
